<template>
	<div class="page">
		<div title="aboutUs" is='headered'></div>
		<div class="Index_title">关于我们</div>
		<div class="aboutUs_text">
			<div>北京安达思创管理顾问公司成立于2011 年，作为国际项目管理协会IPMA、中国（优选法与统筹法）项目管理研究委员会和北京项目管理协会的资深会员单位，专业从事项目管理的培训教育服务。</div>
			<div>人才成长的终身教育导师：少年素质教育（小小项目师、少年发明家）；青年素质教育（国务院教育部1+X职业技能证书的培训评价组织、高校双创就业指导、项目管理专业的本科在线视频慕课平台、本科及硕士学历教育项目、英国法国合作的在线PM专业硕士）；国际项目经理IPMP、PMP培训认证中心。</div>
			<div>企业项目化管理资深顾问：IPMA国际卓越项目管理大奖"管理届奥斯卡"（国际项目管理协会IPMA的全球卓越大奖咨询，为优秀项目提供IPMA表彰的国际舞台)；项目管理咨询（单项目管理咨询、项目管理体系构建、项目管理体系构建）；项目管理企业培训（针对项目的全周期论证、计划控制、收尾评价，提供全套企业项目管理培训课程）。</div>
			<div>公司专注于对项目、对人才的培养，实现”知行合一、致良知；规范创新、行明远”的教育理念：“通过优秀的人做卓越的事”“通过卓越的事培养更优秀的人”。我们是针对项目与人才、培训与教育、创新与发展的教育导师与管理顾问！</div>
		</div>	
		<div class="aboutUs_row">
			<img src="../assets/aboutImg1.jpg"/>
			<img src="../assets/aboutImg2.jpg"/>
		</div>
		<div class="aboutUs_row">
			<img src="../assets/aboutImg3.jpg"/>
			<img src="../assets/aboutImg4.jpg"/>
		</div>
		<!--公共底部-->
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {
			}
		},
		methods: {

		}
	}
</script>

<style scoped="scoped">
	.Index_title {
		width: 1200px;
		margin: 0 auto;
		line-height: 48px;
		font-size: 36px;
		font-weight: bold;
		text-align: center;
		margin-top: 30px;
		margin-bottom: 30px;
	}
	
	.aboutUs_text {
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 60px;
	}
	
	.aboutUs_text div {
		line-height: 30px;
		font-size: 18px;
		color: #51565D;
		text-align: left;
		text-indent: 2em;
	}
	
	.admiss_df{
		width: 300px;
		height: 70px;
		padding-left: 30px;
		line-height: 70px;
		border-bottom: 1px solid #eee;
		background-color: gray;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	.aboutUs_row{
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 40px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	.aboutUs_row img{
		width: 580px;
		height: 380px;
	}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs.vue